
import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import { OperationsManagementService } from "@/api/service-proxies";
import SchoolSelector from '../components/school-selector.vue';
import moment from "moment";
import { exportWithExcelJS } from '@/lib/exportExcel'
import { formatJson } from '@/lib'
// 搜索表单类型定义
interface SearchForm {
  phoneNumber: string;
  tenantId: number | null;
  skipCount: number;
  maxResultCount: number;
}

@Component({
  name: "SchoolAnalysisMainTable",
  components: { SchoolSelector }
})
export default class ScreenTv extends Vue {
  /*********************************************************************
   * 1. 基础配置变量（分页、日期选择器、接口服务）
   ********************************************************************/
  // 分页配置
  pageConfig = {
    pageSizes: [10, 13, 20, 30, 50, 100],
    pageSize: 13,
    currentPage: 1,
    total: 0,
    pageCount: 0
  };

  // 日期选择器配置（禁用未来日期 + 快捷选项）
  pickerOptions = {
    disabledDate(time: Date): boolean {
      return time.getTime() > Date.now(); // 禁用未来日期
    },
    shortcuts: [
      { text: '今天', onClick(picker: any) { picker.$emit('pick', new Date()); } },
      {
        text: '昨天',
        onClick(picker: any) {
          const d = new Date();
          d.setTime(d.getTime() - 3600 * 1000 * 24);
          picker.$emit('pick', d);
        }
      },
      {
        text: '一周前',
        onClick(picker: any) {
          const d = new Date();
          d.setTime(d.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', d);
        }
      }
    ]
  };

  // 接口服务实例
  OperationPointsService = new OperationsManagementService();


  /*********************************************************************
   * 2. 状态变量（数据、加载状态、全屏状态等）
   ********************************************************************/
  // 日期选择器绑定值
  value1 = moment().format('YYYY-MM-DD');
  schoolName = "";
  responsibleName = "";
  tenantRegion = "";
  // 接口请求用的日期（默认当前时间+8小时，适配时区）
  dateday: moment.Moment = moment().add(8, 'hours');
  // 搜索表单
  searchForm: SearchForm = {
    phoneNumber: "",
    tenantId: null,
    skipCount: 0,
    maxResultCount: 13
  };

  // 表格数据
  tableList: any[] = [];
  // 表格加载状态
  isTableLoading = false;

  // 时间显示（当前时分秒、当前日期）
  currentTime = this.getCurrentTime();
  nowDay = moment().add(8, 'hours').format("YYYY年MM月DD日");

  // 全屏相关状态
  isFullScreen = false;
  private fullscreenElement: HTMLElement | null = null;

  // 定时器（时间更新、自动刷新、每日10点更新、表格滚动）
  private timeTimer: NodeJS.Timeout | null = null;
  private autoRefreshTimer: NodeJS.Timeout | null = null;
  private dailyUpdateTimer: NodeJS.Timeout | null = null;
  private tableScrollTimer: NodeJS.Timeout | null = null;

  // 每日10点更新配置
  private targetHour = 10;   // 目标小时（24小时制）
  private targetMinute = 0;  // 目标分钟
  private targetSecond = 0;  // 目标秒


  /*********************************************************************
   * 3. DOM 引用（内容区、全屏容器、表格滚动容器）
   ********************************************************************/
  @Ref('contentArea') contentArea!: HTMLElement; // 主内容区
  @Ref('fullscreenContainer') fullscreenContainer!: HTMLElement; // 全屏容器
  private tableScrollContainer: HTMLElement | null = null; // 表格滚动容器


  /*********************************************************************
   * 4. 表格滚动相关变量
   ********************************************************************/
  tableRowHeight = 60;       // 增加行高以容纳多行文本
  private isScrollEnabled = true;    // 滚动开关（避免并发滚动）
  private isContentEnough = false;   // 内容是否足够滚动（高度差>10px）
  private fakeScrollY = 0;           // 模拟滚动的Y轴位置
  private fakeScrollMax = 100;       // 模拟滚动的最大距离
  isExportLoading = false
  isShowSearch = true
  /*********************************************************************
   * 5. 生命周期钩子
   ********************************************************************/
  mounted() {
    // 初始化时间更新（每秒刷新）
    this.initTimeUpdate();
    // 初始化10分钟自动刷新
    this.initAutoRefresh();
    // 初始化全屏监听
    this.listenFullScreenChange();
    // 初始化表格数据
    this.getTableData();
    // 初始化表格滚动（DOM渲染后执行）
    this.$nextTick(() => this.initTableScroll());
    // 初始化每日10点更新任务
    // this.initDaily10Update();
  }

  beforeDestroy() {
    // 清除所有定时器，避免内存泄漏
    this.clearAllTimers();
    // 退出全屏（若处于全屏状态）
    if (this.isFullScreen) this.exitFullScreen();

  }

  tableRowClassName({ row, rowIndex }: { row: any; rowIndex: number }): string {
    if (row.actualArriveNum > 0 && (row.wxPhoneOffLineCount > 0 || row.deviceOffLineCount > 0)) {
      return 'success-row'
    }
    return ''
  }
  /*********************************************************************
   * 6. 监听事件（表格数据变化、全屏状态变化）
   ********************************************************************/
  // 表格数据变化后，重新初始化滚动
  @Watch('tableList')
  onTableListChange() {
    setTimeout(() => this.initTableScroll(), 500);
  }

  // 全屏状态变化后，重新初始化滚动（适配全屏高度）
  @Watch('isFullScreen')
  onFullScreenChange() {
    setTimeout(() => this.initTableScroll(), 300);
  }
async exportSchoolAnalysis() {
  if (this.tableList.length == 0) {
    this.$message.error('数据未加载成功，请稍后重试!');
    return;
  }

  this.isExportLoading = true;
  try {
    const header = [
      '学校名称', '负责人', '区域', '经营类型', '收费类型', '应到人数', '实到人数', '未到人数',
      '请假人数', '实到占比', '设备在线', '设备离线', '微信电话在线', '微信电话离线','七天收入', '七天打电话数','未绑定微信电话数', '未录人脸数',
      '未绑定家长数', '非会员人数'
    ];

    const filterVal = [
      'tenantName', 'responsibleName', 'tenantRegion', 'businessType', 'billingType',
      'shouldArriveNum', 'actualArriveNum', 'notInSchoolNum', 'leaveNum', 'rate', 'onLineDeviceCount', 'deviceOffLineCount',
      'wxPhoneOnLineCount', 'wxPhoneOffLineCount', 'moneySevenDay','wxCallServenDay', 'parentNotBindWxCallNum', 'notFaceImgNum',
      'noBindParentNum', 'noVipCount'
    ];
    let data = formatJson(filterVal, this.tableList);

    // 在 formatJson 之后转换数据
    data = data.map((row: any[]) => {
      // 根据 filterVal 中字段的位置来转换
      const billingTypeIndex = filterVal.indexOf('billingType');
      const businessTypeIndex = filterVal.indexOf('businessType');

      if (billingTypeIndex !== -1) {
        row[billingTypeIndex] = row[billingTypeIndex] == 0 ? '自营' : row[billingTypeIndex] == 1 ? '代理' : '重点保障';
      }
      if (businessTypeIndex !== -1) {
        row[businessTypeIndex] = row[businessTypeIndex] == 0 ? 'C端' : row[businessTypeIndex] == 1 ? 'B端' : 'C端B端';
      }

      return row;
    });

    await exportWithExcelJS(header, data, '各学校数据');
  } catch (error) {
    console.error('导出失败:', error);
    this.$message.error('导出失败，请重试');
  } finally {
    this.isExportLoading = false;
  }
}

  private getCurrentTime(): string {
    // 方法1：使用moment（推荐）
    return moment().format("HH:mm:ss");

    // 方法2：使用原生Date（备选）
    // const now = new Date();
    // now.setHours(now.getHours() + 8); // 添加8小时调整时区
    // const pad = (num: number) => String(num).padStart(2, "0");
    // return `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  }

  private initTimeUpdate() {
    // 立即更新一次
    this.currentTime = this.getCurrentTime();
    this.nowDay = moment().format("YYYY年MM月DD日");

    // 然后设置定时器
    this.timeTimer = setInterval(() => {
      this.currentTime = this.getCurrentTime();
      this.nowDay = moment().format("YYYY年MM月DD日");
    }, 1000);
  }


  /*********************************************************************
   * 8. 全屏相关方法（切换全屏、退出全屏、监听全屏变化）
   ********************************************************************/
  // 切换全屏/退出全屏
  toggleFullScreen() {
    if (!this.isFullScreen) {
      this.isShowSearch = false
      this.enterFullScreen();
    } else {
      this.exitFullScreen();
      this.isShowSearch = true

    }
  }

  // 进入全屏
  private enterFullScreen() {
    if (this.fullscreenContainer.requestFullscreen) {
      this.fullscreenContainer.requestFullscreen().then(() => {
        this.isFullScreen = true;
        this.fullscreenElement = this.fullscreenContainer;
      });
    } else if ((this.fullscreenContainer as any).webkitRequestFullscreen) {
      (this.fullscreenContainer as any).webkitRequestFullscreen();
      this.isFullScreen = true;
      this.fullscreenElement = this.fullscreenContainer;
    } else if ((this.fullscreenContainer as any).msRequestFullscreen) {
      (this.fullscreenContainer as any).msRequestFullscreen();
      this.isFullScreen = true;
      this.fullscreenElement = this.fullscreenContainer;
    }
  }

  // 退出全屏
  private exitFullScreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen().then(() => {
        this.isFullScreen = false;
        this.fullscreenElement = null;
      });
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
      this.isFullScreen = false;
      this.fullscreenElement = null;
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
      this.isFullScreen = false;
      this.fullscreenElement = null;
    }
  }

  // 监听浏览器全屏状态变化（适配手动按F11全屏的场景）
  private listenFullScreenChange() {
    const handleChange = () => {
      const isFull = !!(
        document.fullscreenElement ||
        (document as any).webkitFullscreenElement ||
        (document as any).msFullscreenElement
      );
      // 仅当全屏元素是当前容器时，更新状态
      this.isFullScreen = isFull && document.fullscreenElement === this.fullscreenContainer;
    };
    document.addEventListener("fullscreenchange", handleChange);
    document.addEventListener("webkitfullscreenchange", handleChange);
    document.addEventListener("MSFullscreenChange", handleChange);
  }


  /*********************************************************************
   * 9. 数据请求方法（表格数据加载、日期变化处理）
   ********************************************************************/
  // 日期选择器变化时，更新请求日期
  // handleDateChange() {
  //   this.dateday = this.value1
  //     ? moment(this.value1).add(8, 'hours')
  //     : moment().add(8, 'hours');
  // }

  // 获取表格数据（核心接口请求）
  getTableData(): Promise<void> {
    this.isTableLoading = true;
    // 注意：此处固定日期为演示用，实际应删除，使用上面handleDateChange更新的dateday
    // this.dateday = moment('2025-10-08');

    return this.OperationPointsService.getStudentDailyAttendanceStaticEveryDay(this.value1, this.responsibleName, this.schoolName, this.tenantRegion,null,null)
      .then((result: any) => {
        this.tableList = result;
        console.log(`表格数据加载完成，共 ${result.length} 条`);
      })
      .catch((error: any) => {
        this.$message.error('请求失败，请重试');
        console.error('数据请求错误:', error);
      })
      .finally(() => {
        this.isTableLoading = false;
        // 数据加载完成后，重新初始化滚动（确保DOM更新）
        setTimeout(() => this.initTableScroll(), 300);
      });
  }


  /*********************************************************************
   * 10. 自动刷新方法（10分钟刷新、每日10点刷新）
   ********************************************************************/
  // 初始化10分钟自动刷新（600000ms = 10分钟）
  private initAutoRefresh() {
    this.autoRefreshTimer = setInterval(() => {
      console.log('执行10分钟自动刷新');
      this.pageConfig.currentPage = 1; // 重置到第一页
      this.getTableData();
    }, 600000);
  }

  // 初始化每日10点更新任务（循环预约）
  private initDaily10Update() {
    // 计算当前到最近10点的延迟时间（毫秒）
    const delay = this.calculateDelayToTargetTime();
    console.log(`每日10点更新任务已预约，将在 ${(delay / 1000 / 60).toFixed(1)} 分钟后执行`);

    // 定时执行：首次执行后，自动预约次日任务
    this.dailyUpdateTimer = setTimeout(async () => {
      await this.executeDailyUpdate();
      this.initDaily10Update(); // 预约次日10点
    }, delay);
  }

  // 计算当前到目标时间（10:00:00）的延迟时间
  private calculateDelayToTargetTime(): number {
    const now = moment();
    // 当天10点的时间对象
    const todayTarget = moment()
      .hour(this.targetHour)
      .minute(this.targetMinute)
      .second(this.targetSecond)
      .millisecond(0);

    // 若当前已过今天10点，目标时间改为明天10点
    if (now.isAfter(todayTarget)) {
      return todayTarget.add(1, 'day').valueOf() - now.valueOf();
    }
    // 未过则直接用今天10点
    return todayTarget.valueOf() - now.valueOf();
  }

  // 执行每日更新任务
  private async executeDailyUpdate() {
    console.log(`执行每日10点数据更新（当前时间：${moment().format('YYYY-MM-DD HH:mm:ss')}）`);
    try {
      await this.getTableData(); // 复用表格数据请求方法
    } catch (error) {
      console.error('每日10点数据更新失败：', error);
      this.retryDailyUpdate(); // 失败后重试
    }
  }

  // 每日更新失败后重试（10分钟后）
  private retryDailyUpdate() {
    const retryDelay = 10 * 60 * 1000; // 10分钟
    console.log(`将在 ${retryDelay / 1000 / 60} 分钟后重试每日更新`);

    this.dailyUpdateTimer = setTimeout(async () => {
      await this.executeDailyUpdate();
      if (this.dailyUpdateTimer) clearTimeout(this.dailyUpdateTimer);
      this.initDaily10Update(); // 重试后仍需预约次日任务
    }, retryDelay);
  }


  /*********************************************************************
   * 11. 表格滚动核心逻辑
   ********************************************************************/
  // 初始化表格滚动（入口方法）
  private initTableScroll() {
    // 清除现有滚动定时器
    if (this.tableScrollTimer) {
      clearInterval(this.tableScrollTimer);
      this.tableScrollTimer = null;
    }

    // 尝试查找滚动容器，最多重试5次
    const tryFindContainer = (retry = 0) => {
      if (retry > 5) return;
      const found = this.findScrollContainer();
      if (found) {
        // 计算滚动条件并启动滚动
        this.calculateContentStatus();
        this.isContentEnough ? this.startNormalScroll() : this.startFakeScroll();
      } else {
        setTimeout(() => tryFindContainer(retry + 1), 500);
      }
    };

    tryFindContainer();
  }

  // 查找表格滚动容器（.el-table__body-wrapper）
  private findScrollContainer(): boolean {
    let container: HTMLElement | null = null;

    // 优先从内容区查找表格滚动容器
    if (this.contentArea) {
      container = this.contentArea.querySelector('.el-table .el-table__body-wrapper') as HTMLElement;
    }
    // 兜底全局查找
    if (!container) {
      container = document.querySelector('.el-table .el-table__body-wrapper') as HTMLElement;
    }

    if (container) {
      this.tableScrollContainer = container;
      // 强制开启滚动样式
      this.tableScrollContainer.style.overflowY = 'auto';
      this.tableScrollContainer.style.overflowX = 'auto';
      return true;
    } else {
      console.warn('未找到表格滚动容器（.el-table__body-wrapper）');
      return false;
    }
  }

  // 判断内容是否足够滚动（高度差>10px）
  private calculateContentStatus() {
    if (!this.tableScrollContainer) {
      this.isContentEnough = false;
      return;
    }
    const containerHeight = this.tableScrollContainer.clientHeight;
    const contentHeight = this.tableScrollContainer.scrollHeight;
    this.isContentEnough = (contentHeight - containerHeight) > 10;
    console.log('滚动条件：', { containerHeight, contentHeight, isContentEnough: this.isContentEnough });
  }

  // 正常滚动（内容足够时）
  private startNormalScroll() {
    console.log('启动正常滚动');
    this.tableScrollTimer = setInterval(() => {
      if (!this.tableScrollContainer || !this.isScrollEnabled) return;

      this.isScrollEnabled = false;
      const container = this.tableScrollContainer;
      const scrollableHeight = container.scrollHeight - container.clientHeight;
      // 向上滚动2行（可调整）
      let targetScrollTop = container.scrollTop + (2 * this.tableRowHeight);

      // 循环滚动：滚到底部后从顶部重新开始
      if (targetScrollTop > scrollableHeight) {
        targetScrollTop = 0;
      }

      // 平滑滚动动画（600ms完成）
      this.smoothScroll(container, targetScrollTop, 600);
    }, 5000); // 每5秒滚动一次
  }

  // 模拟滚动（内容不足时）
  private startFakeScroll() {
    console.log('启动模拟滚动');
    if (!this.tableScrollContainer) return;

    const container = this.tableScrollContainer;
    this.fakeScrollY = 0; // 重置滚动位置

    this.tableScrollTimer = setInterval(() => {
      if (!this.isScrollEnabled) return;
      this.isScrollEnabled = false;

      // 向上滚动指定距离
      const targetY = this.fakeScrollMax;
      // 平滑滚动动画（600ms完成）
      this.smoothScroll(container, targetY, 600, () => {
        // 滚动完成后复位，制造往复效果
        setTimeout(() => {
          container.scrollTop = 0;
          this.fakeScrollY = 0;
          this.isScrollEnabled = true;
        }, 500);
      });
    }, 5000); // 每5秒滚动一次
  }

  // 平滑滚动动画（通用方法）
  private smoothScroll(
    container: HTMLElement,
    targetTop: number,
    duration: number,
    callback?: () => void
  ) {
    const start = container.scrollTop;
    const change = targetTop - start;
    const startTime = performance.now();

    const animateScroll = (timestamp: number) => {
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // 缓动函数：使滚动更自然（先慢后快再慢）
      const easeProgress = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      container.scrollTop = start + change * easeProgress;

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      } else {
        this.isScrollEnabled = true;
        if (callback) callback();
      }
    };

    requestAnimationFrame(animateScroll);
  }


  /*********************************************************************
   * 13. 工具方法（清除定时器、返回上一页）
   ********************************************************************/
  // 清除所有定时器
  private clearAllTimers() {
    if (this.timeTimer) clearInterval(this.timeTimer);
    if (this.autoRefreshTimer) clearInterval(this.autoRefreshTimer);
    if (this.tableScrollTimer) clearInterval(this.tableScrollTimer);
    if (this.dailyUpdateTimer) clearTimeout(this.dailyUpdateTimer);
  }

  // 返回上一页
  goBack() {
    this.$router.back();
  }
}
